import React from 'react';
import PropTypes from 'prop-types';
import './FilterButton.scss';

const FilterButton = props => (
  <button
    className={`filter-button ${props.selected ? 'filter-button--selected' : ''}`}
    onClick={() => props.handleClick(props.type)}
  >
    <i className={`filter-icon ${props.selected ? props.icon : ''}`} />
    <span className="filter-name">{props.label}</span>
  </button>
);

FilterButton.propTypes = {
  selected: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default FilterButton;
